import SimpleDialog from "@@components/simple-dialog/SimpleDialog";
import useContent from "@@hooks/useContent";

interface ILeavePageModalProps {
  confirmLabel?: string;
  message?: string;
  onCancel: () => void;
  onConfirm: () => void;
  title: string;
  width?: number;
}

const LeavePageModal: React.FC<ILeavePageModalProps> = ({
  confirmLabel,
  message,
  onCancel,
  onConfirm,
  title,
}) => {
  const {
    content: { itemDetails: commonContent },
  } = useContent();
  return (
    <SimpleDialog
      action={{
        label: confirmLabel ?? commonContent.leave,
        onClick: onConfirm,
      }}
      onClose={onCancel}
      title={title}
    >
      {message ?? commonContent.leavePageDescription}
    </SimpleDialog>
  );
};

export default LeavePageModal;
